import {
  CHANGE_REPORT_CAR,
  CLEAR_REPORT_CAR
} from '../actions/reportCarActions'

const initialState = {
  id: ''
}

const reportCarReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHANGE_REPORT_CAR:
      return Object.assign(
        {},
        state,
        {
          id: action.data
        }
      )
    case CLEAR_REPORT_CAR:
      return Object.assign(
        {},
        state, 
        initialState
      )
    default:
      return state
  }
}

export default reportCarReducer